import {
  GETKYBAPPROVEREJECT_SUCCESS,
  GETKYBAPPROVEREJECT_FAILED,
  RESET_GETKYBAPPROVEREJECT,
  LOADING_GETKYBAPPROVEREJECT,
  NETWORK_ERROR_GETKYBAPPROVEREJECT,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetgetKybApproveReject = () => {
  return { type: RESET_GETKYBAPPROVEREJECT };
};

const getKybApproveRejectReq = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETKYBAPPROVEREJECT });
  await partnerServices
    .post("getKybApproveReject", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.data.status) {
        case "Approved":
          dispatch(getKybApproveRejectsuccess(res.data));
          break;
        default:
          dispatch(getKybApproveRejectFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({
        type: NETWORK_ERROR_GETKYBAPPROVEREJECT,
        payload: err,
      });
    });
};
function getKybApproveRejectsuccess(data) {
  return {
    type: GETKYBAPPROVEREJECT_SUCCESS,
    payload: data,
  };
}
function getKybApproveRejectFailed(data) {
  return {
    type: GETKYBAPPROVEREJECT_FAILED,
    payload: data,
  };
}

export { resetgetKybApproveReject, getKybApproveRejectReq };
